import { getChemistrySequenceDirection, getChemistrySequenceMetrics } from './chemistryAnalysisUtils';

export function buildChemistryAnalysisCopy({
  result,
  nameA,
  nameB,
  language,
  t,
}) {
  const safeNameA = nameA || 'A';
  const safeNameB = nameB || 'B';
  const tx = (key, options = {}) => {
    if (typeof t === 'function') {
      return t(`chemistry_result.analysis_sequence.${key}`, options);
    }
    return options.defaultValue || key;
  };
  const metrics = getChemistrySequenceMetrics(result, language);
  const direction = getChemistrySequenceDirection(result, safeNameA, safeNameB);

  return {
    intro: {
      eyebrow: tx('intro.eyebrow'),
      title: tx('intro.title'),
    },
    scanA: {
      title: tx('scan.person', { name: safeNameA }),
      items: [tx('scan.eye'), tx('scan.depth'), tx('scan.approachability')],
    },
    scanB: {
      title: tx('scan.person', { name: safeNameB }),
      items: [tx('scan.eye'), tx('scan.depth'), tx('scan.approachability')],
    },
    compare: {
      comfort: tx('compare.comfort'),
      attraction: tx('compare.attraction'),
      comfortLine: tx('compare.comfort_line'),
      attractionLine: tx('compare.attraction_line'),
    },
    direction: {
      title: tx('direction.title'),
      summary: tx(`direction.${direction.titleKey}`, { nameA: safeNameA, nameB: safeNameB }),
      balanced: direction.lead === 'balanced',
      lead: direction.lead,
    },
    score: {
      title: tx('final.title'),
      outOf100: tx('final.out_of_100'),
      viewResult: tx('final.view_result'),
      gradeLabel: metrics.grade.label,
      gradeCode: metrics.grade.code,
      interpretation: metrics.grade.interpretation,
    },
  };
}
